import { Component, ChangeDetectorRef, Input, Output, EventEmitter } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { EventServiceProvider } from '../../providers/event-service/event-service';
import { ConfigureServiceProvider } from '../../providers/configure-service/configure-service';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
})
export class HomePage {
  isReg: boolean = false;
  // showlogin: boolean = false;
  channelDataSrc: any = [];
  screenDataSrc: any = [];
  showchannel: boolean = false;
  showscreen: boolean = false;
  showpreview: boolean = true;
  hideContainer: boolean = !false;
  _previewhtml: string = "";
  offLeft: string = "0px";
  offHeight: string;
  regObj: any;
  loginSuccess: boolean = false;
  showlogin: boolean = true;
  regId: any;
  @Input() sharePageActive:any;
  @Input() sharedData: any;
  @Output() loginSuccessMessageStatus = new EventEmitter();
  constructor(public navCtrl: NavController, public navParams: NavParams, private cdr: ChangeDetectorRef, public eventObj: EventServiceProvider, public config: ConfigureServiceProvider) {

  }
  handleOnLogin(reg, stop = false) {
    if (reg.state == true) {
      this.loginSuccess = reg.state;
      this.regId = reg.regID;
      this.showlogin = false;
    } else {
      this.loginSuccess = reg.state;
      this.showlogin = true;
    }
    this.cdr.detectChanges();
  }
  ngAfterViewInit() {
    this.showpreview = false;
    this.eventObj.event$.subscribe(data => {
      if (data.event === 'hide-all-panels') {
        this.hideAllPanels();
      }

      if (data.event === 'trigger-screen-panel') {
        this.showScreenPanel(data.data);
      }

      if (data.event === 'epcDesk:reload:channels') {
        this.handleOnLogin(this.regObj);
      }



      if (data.event === "epcDesk_CMD") {
        let _data = data.data;
        let _cmd = _data.cmd;
        if (_cmd === "logout") {
          this.channelDataSrc = [];
          this.screenDataSrc = [];
          this.showchannel = false;
          this.showscreen = false;
          localStorage.clear();
          this.config.setUserLevel(false);
          this.eventObj.trigEvent({ event: "clearDesktop", data: {} });
          this.config.setServerMode('dev');
          this.handleOnLogin({ state: false });
          setTimeout(() => {

            this.eventObj.trigEvent({ event: "epcDesk-pagepreview-reset", data: {} });
            this.eventObj.trigEvent({ event: "init-login-process", data: {} });
          }, 0)
        }
        if (_cmd === "searchepc") {
          this.eventObj.trigEvent({ event: "epcDesk:search", data: { search: _data.info, channel: this.showchannel, screen: this.showscreen } });
        }
      }

    })
    if (!this.isReg) {
      this.eventObj.trigEvent({ event: "init-login-process", data: {} });
    }
    console.log("home init - Deskready!");


  }
  showPagePanel() {
    console.log("showPagePanel");
    this.eventObj.trigEvent({ event: "epcDesk-pagepreview-show", data: { app: null, mode: "navigate" } });
  }

  hideAllPanels() {
    this.showlogin = false;
    this.showchannel = false;
    this.showscreen = false;
    this.showpreview = false;
    this.hideContainer = true;
  }

  showScreenPanel(data) {
    this.hideAllPanels();
    this.screenDataSrc = data;
    this.showscreen = true;
    this.hideContainer = false;
  }


  loginSuccessMessage(ev) {
    this.loginSuccessMessageStatus.emit(ev);
  }

  closePanel() {
    this.hideContainer = true;
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts